import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Bulk-load or update materials from a CSV
 * @primary CSV upload + preview
 * @persona paola-admin-belora
 */
export const Route = createFileRoute("/app/c/$customerSlug/materials/import")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
